/**
 * @file
 * Attaches the behaviors for the wysiwyg components.
 */

(function ($, Drupal) {
  'use strict';

  Drupal.behaviors.wysiwyg = {
    attach: function attach(context) {
      if ($('table thead', context).length > 0) {
        $('table thead', context).each(function () {
          $(this).closest('table').addClass('has-th');
        });
        $('table td', context).each(function () {
          const tdIndex = $(this).index();
          const thTable = $(this)
            .closest('table')
            .find('th')
            .eq(tdIndex)
            .html();

          if (typeof thTable !== 'undefined') {
            $(this).attr('data-label', thTable);
          }
        });
      }
    }
  };
})(jQuery, Drupal);
